module.exports = "/static/assets/0de80419b1d8d06b4bfd91b91ad98063.png";